/**
 * @generated SignedSource<<b685dcae22fbe8caf8040f1eb0dff732>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimpleMenuMainNavigation_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableUserAccounts",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "d77c84dad777976c9c7ce9c1c8c52743";

module.exports = node;
